import React, { useEffect, useState } from "react";

const LINES = [
  "PJP-NET · CORE v4.2 · NOMINAL",
  "26,534 NODES · SYNCHRONIZED",
  "GPT-5.2 INFERENCE · ONLINE",
  "FAA REGISTRY · MIRROR OK",
  "TLS 1.3 · AES-256 · ENCRYPTED",
  "GEO · 120 COUNTRIES · LIVE",
  "JOB ROUTER · < 15 MIN P95",
  "AOG DISPATCH · ARMED",
  "AEROINTEL SEARCH · READY",
];

export default function Telemetry() {
  const [i, setI] = useState(0);
  const [tick, setTick] = useState(Date.now());

  useEffect(() => {
    const id = setInterval(() => setI((n) => (n + 1) % LINES.length), 2200);
    const t = setInterval(() => setTick(Date.now()), 1000);
    return () => { clearInterval(id); clearInterval(t); };
  }, []);

  const utc = new Date(tick).toISOString().replace("T", " ").slice(0, 19) + " UTC";

  return (
    <div className="card hud-corners !p-5 relative">
      <span className="hud-c-bl" /><span className="hud-c-br" />

      <div className="flex items-center justify-between mb-4">
        <div className="mono text-[10px] uppercase tracking-[0.2em] text-white/45">// PJP·OPS</div>
        <span className="status-pill">Online</span>
      </div>

      <div className="mono text-[10px] text-white/55 mb-3">{utc}</div>

      <div className="space-y-1.5 min-h-[172px]">
        {LINES.map((l, idx) => {
          const active = idx === i;
          return (
            <div key={idx} className={`mono text-[11px] transition-colors duration-300 ${active ? "text-sky" : "text-white/25"}`}>
              <span className={active ? "text-sky" : "text-white/25"}>▸ </span>{l}
            </div>
          );
        })}
      </div>

      <div className="mt-5 pt-4 border-t border-white/[0.05] grid grid-cols-3 gap-3">
        <div>
          <div className="mono text-[9px] text-white/40 uppercase tracking-widest">LAT</div>
          <div className="mono text-[12px] text-white">40.85°N</div>
        </div>
        <div>
          <div className="mono text-[9px] text-white/40 uppercase tracking-widest">LON</div>
          <div className="mono text-[12px] text-white">74.06°W</div>
        </div>
        <div>
          <div className="mono text-[9px] text-white/40 uppercase tracking-widest">ALT</div>
          <div className="mono text-[12px] text-white">FL410</div>
        </div>
      </div>
    </div>
  );
}
